"use client";

import { ChevronDown } from "components/SVG";
import React from "react";

import type { LocaleOfStoreType } from "@beautypie/core";
import { ToggleButton } from "components/SiteChrome/ToggleButton";
import type { MerchandisingCategory } from "@shared/graphql.types";
import { list, listItem, icon, container, separatorRight } from "./style.css";
import { withStorePrefix } from "app/utils";

type Props = {
  items: MerchandisingCategory[];
  moreMenu: MerchandisingCategory;
};

const fallbackItems = [
  {
    title: "New In",
    href: "/shop/whatsnew"
  },
  {
    title: "Bestsellers",
    href: "/shop/bestsellers"
  },
  {
    title: "Join Beauty Pie+",
    href: "/bp/join/join-beauty-pie"
  },
  {
    title: "Skincare Quiz",
    href: "/quiz/skincare"
  }
];

export const NavBarFallback = ({ locale }: { locale: LocaleOfStoreType }) => (
  <div data-testid="nav-bar" className={container}>
    <ul className={list}>
      {fallbackItems
        .map((item) => ({
          ...item,
          href: withStorePrefix(item.href, locale)
        }))
        .map((item) => (
          <li key={item.title} className={listItem} track-click="NavBar">
            <a href={item.href}>{item.title}</a>
          </li>
        ))}
    </ul>
  </div>
);

export const NavBar: React.FC<Props> = ({ items, moreMenu }) => {
  return (
    <div data-testid="nav-bar" className={container}>
      <ul className={list}>
        {items?.map((item) => {
          return (
            <li key={item.id} className={separatorRight}>
              {item.items?.length ? (
                <ToggleButton
                  aria-controls="main-menu"
                  className={`${listItem}`}
                  track-click="NavBar"
                  aria-label={`open ${item.title} menu`}
                  onClick={() => {
                    // automatically expand the first category...
                    (
                      document.querySelector(
                        "#main-menu li.level_0 button"
                      ) as HTMLButtonElement
                    )?.setAttribute("aria-expanded", "true");

                    if (
                      document.querySelector(
                        `[aria-controls="more-menu"][aria-expanded=true]`
                      )
                    ) {
                      (
                        document.querySelector(
                          `#more-menu [aria-controls="more-menu"]`
                        ) as HTMLButtonElement
                      )?.click();
                    }
                  }}
                >
                  {item.title}

                  <ChevronDown className={icon} />
                </ToggleButton>
              ) : (
                <a
                  className={listItem}
                  href={item.href ?? undefined}
                  track-click="NavBar"
                >
                  {item.title}
                </a>
              )}
            </li>
          );
        })}
        {moreMenu.items?.map((item) => {
          return (
            <li key={item.id}>
              <ToggleButton
                aria-controls="more-menu"
                className={`${listItem}`}
                track-click="NavBar"
                aria-label={`open ${item.title} menu`}
                onClick={() => {
                  if (
                    document.querySelector(
                      `[aria-controls="main-menu"][aria-expanded=true]`
                    )
                  ) {
                    (
                      document.querySelector(
                        `#main-menu [aria-controls="main-menu"]`
                      ) as HTMLButtonElement
                    )?.click();
                  }
                }}
              >
                {item.title}

                <ChevronDown className={icon} />
              </ToggleButton>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
